var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"diffTablesModal",attrs:{"id":"diff-tables-dialog","modal-class":_vm.theme,"hide-footer":"","centered":"","body-class":"modal__confirm","size":"lg"}},[_c('DiffTables',{attrs:{"diffGroup":_vm.diffGroup,"name":_vm.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }